import { createAsyncThunk } from '@reduxjs/toolkit'
import { WorkspaceAgent } from '../../../../../api/workspaceAgent'

export const cancelSubscription = createAsyncThunk('workspaces/subscription/cancel', async ({}, thunkApi) => {
  try {
    const response = await WorkspaceAgent.cancelSubscription()

    return response
  } catch (error) {
    return thunkApi.rejectWithValue(error?.response?.data)
  }
})
